import React, { useContext } from 'react';
import PricingContext from '../../../context/pricing';
import { SIGNUP_URL } from '../../../constants/pricing/config';

const FooterCallout = () => {
  const { state } = useContext(PricingContext);

  return (
    <div className="p-relative p-bottom-5 text-center bg-offset-short-light-blue-bottom">
      <div className="row row--small">
        <div className="card">
          <h3 className="m-bottom-5 is-regular">
            Want to learn more about how{' '}
            <strong>
              SendGrid{' '}
              {state.activeTab === 'mc' ? 'Marketing Campaigns' : 'Email API'}
            </strong>{' '}
            can work for you? Reach out to our sales team today.
          </h3>
          <div className="btn-list">
            <a
              href={SIGNUP_URL}
              title="Start Free"
              className="btn btn--primary btn--large"
              data-gtm-track="true"
              data-gtm-event-type="cta"
            >
              Start for free
            </a>
            <a
              href="/contact-us-form/"
              title="Contact sales"
              className="btn btn--secondary btn--large"
            >
              Contact sales
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FooterCallout;
